module.exports = __webpack_public_path__ + "static/media/bunny.2965dab1.jpg";